import { Injectable, inject } from '@angular/core';

import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import type { User } from '@core/account-types';
import { HttpApiService } from '@core/http-legacy';

@Injectable({ providedIn: 'root' })
export class UserHttpClient {
  protected readonly httpApi = inject(HttpApiService);

  public fetchCollection(): Observable<User[]> {
    return this.httpApi.get('/admins').pipe(map(response => response.admins));
  }
}
